import { render, staticRenderFns } from "./DaysRejectedWidget.vue?vue&type=template&id=9d25cd88&scoped=true&"
import script from "./DaysRejectedWidget.vue?vue&type=script&lang=js&"
export * from "./DaysRejectedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d25cd88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d25cd88')) {
      api.createRecord('9d25cd88', component.options)
    } else {
      api.reload('9d25cd88', component.options)
    }
    module.hot.accept("./DaysRejectedWidget.vue?vue&type=template&id=9d25cd88&scoped=true&", function () {
      api.rerender('9d25cd88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/widgets/DaysRejectedWidget.vue"
export default component.exports